import "./App.scss";
import Header from "./components/Header";
import Home from "./pages/Home";
import Form from "./pages/Form";
import Login from "./pages/Login";
import Backoffice from "./pages/Backoffice";
import CreateForm from "./pages/CreateForm";
import UpdateForm from "./pages/UpdateForm";
import Answers from "./pages/Answers";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

//import fonts
import "./assets/fonts/AvertaStdPE-Regular.ttf";
import "./assets/fonts/AvertaStdPE-Regular.eot";
import "./assets/fonts/AvertaStdPE-Regular.svg";
import "./assets/fonts/AvertaStdPE-Regular.woff";
import "./assets/fonts/AvertaStdPE-Regular.woff2";
import "./assets/fonts/AvertaStdPE-Bold.ttf";
import "./assets/fonts/AvertaStdPE-Bold.eot";
import "./assets/fonts/AvertaStdPE-Bold.svg";
import "./assets/fonts/AvertaStdPE-Bold.woff";
import "./assets/fonts/AvertaStdPE-Bold.woff2";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/form/:slug" element={<Form />}></Route>
        <Route path="/backoffice/login" element={<Login />}></Route>
        <Route path="/backoffice" element={<Backoffice />}></Route>
        <Route path="/backoffice/create" element={<CreateForm />}></Route>
        <Route path="/backoffice/update/:id" element={<UpdateForm />}></Route>
        <Route path="/backoffice/answers/:id" element={<Answers />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
